export type StatusConfig = {
  backgroundColor: string;
  dotColor: string;
};

export type ClientRequestStatus = {
  [x: string]: StatusConfig;
};

export const ReviewerStatusMap: ClientRequestStatus = {
  Onboarding: {
    backgroundColor: '#FFF9E6',
    dotColor: '#FDC716',
  },
  Invited: {
    backgroundColor: '#E7F0FD',
    dotColor: '#4288F0',
  },
  Active: {
    backgroundColor: '#E1F4EA',
    dotColor: '#379564',
  },
  'Not Ready': {
    backgroundColor: '#F0F2F5',
    dotColor: '#879AAB',
  },
  Archived: {
    backgroundColor: '#E0E4EB',
    dotColor: '#879AAB',
  },
};

export const ClientRequestStatusMap: ClientRequestStatus = {
  'In Progress': {
    backgroundColor: '#FFF9E6',
    dotColor: '#FDC716',
  },
  Submitted: {
    backgroundColor: '#E1F4EA',
    dotColor: '#039648',
  },
  'Under Review': {
    backgroundColor: '#E7F0FD',
    dotColor: '#4288F0',
  },
  'Assigned/Under-Review': {
    backgroundColor: '#E7F0FD',
    dotColor: '#4288F0',
  },
  Closed: {
    backgroundColor: '#E0E4EB',
    dotColor: '#546778',
  },
  Cancelled: {
    backgroundColor: '#F0F2F5',
    dotColor: '#879AAB',
  },
  'Re-Opened': {
    backgroundColor: '#F9E9FC',
    dotColor: '#632871',
  },
};
